/**
 * Local/dev only: the backend (with SMS disabled) echoes the OTP it would have texted as
 * `devOtp: { code, mobile }` in the response body. The API clients pass every response here,
 * and <DevOtpBanner /> shows the code on screen. Production builds never emit anything.
 */
export const DEV_OTP_EVENT = 'casmashop:dev-otp';

export interface DevOtpPayload {
  code: string;
  mobile: string;
}

export const emitDevOtpFromResponse = (data: unknown): void => {
  if (process.env.NODE_ENV === 'production' || typeof window === 'undefined') return;
  const otp = (data as { devOtp?: DevOtpPayload } | null)?.devOtp;
  if (otp?.code) {
    window.dispatchEvent(new CustomEvent<DevOtpPayload>(DEV_OTP_EVENT, { detail: otp }));
  }
};
